// lib/profile.js
// =============================================================================
// Client-side profile and intake localStorage helpers, extracted from the
// retired lib/hydration.js. The NHS engine that used to live beside these is
// server-side only (routes/wtrHydration.js); no scoring weight, absorption
// factor, or formula logic may ever return to client code.
// =============================================================================

export function readProfile() {
  try { return JSON.parse(localStorage.getItem("wtr_profile") || "{}"); } catch (e) { return {}; }
}

export function readIntake() {
  try { return JSON.parse(localStorage.getItem("wtr_intake") || "{}"); } catch (e) { return {}; }
}

export function writeIntake(intake) {
  try { localStorage.setItem("wtr_intake", JSON.stringify(intake)); } catch (e) {}
}
